/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S6_P1Inputs */

const en_guide_large_json_files_s6_p1 = /** @type {(inputs: Guide_Large_Json_Files_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON runs entirely in your browser, so performance depends on your device. For optimal results with larger files:`)
};

const ko_guide_large_json_files_s6_p1 = /** @type {(inputs: Guide_Large_Json_Files_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON은 전적으로 브라우저에서 실행되므로 성능은 기기에 따라 달라집니다. 큰 파일에서 최적의 결과를 얻으려면:`)
};

const ja_guide_large_json_files_s6_p1 = /** @type {(inputs: Guide_Large_Json_Files_S6_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONはすべてブラウザ内で実行されるため、パフォーマンスはデバイスに依存します。大きなファイルで最適な結果を得るには：`)
};

/**
* | output |
* | --- |
* | "PureJSON runs entirely in your browser, so performance depends on your device. For optimal results with larger files:" |
*
* @param {Guide_Large_Json_Files_S6_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s6_p1 = /** @type {((inputs?: Guide_Large_Json_Files_S6_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S6_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s6_p1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s6_p1(inputs)
	return ja_guide_large_json_files_s6_p1(inputs)
});